<div class="hvac-alert-chip" [ngClass]="'hvac-alert-chip-' + alertType">
    <span class="hvac-label hvac-alert-chip-text"><ng-content></ng-content></span>
</div>
